import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

function AdminPrivateRoute({ children }) {
  const user = useSelector((state) => state.userDetails.value);

  const isAdmin = user?.UserRole === "Admin";
  return isAdmin ? children : <Navigate to="/HUBExperience/companysetup" />;
}

export default AdminPrivateRoute;
